module.exports = __webpack_public_path__ + "static/media/03_soldered_graphics_connector.29b76311.jpg";